import React from "react";

const guidelines = [
  {
    title: "Group safety",
    points: [
      "Stay with the group throughout the trek. Do not head off alone.",
      "Let your trek leader know before stepping away, even briefly.",
      "Popular trails can get crowded, especially on weekends. Stay alert and keep your group in sight.",
    ],
  },
  {
    title: "Follow your trek leaders",
    points: [
      "Listen to your trek leaders and follow their safety instructions.",
      "Avoid making independent decisions that could put you or others at risk.",
      "Tell your trek leader promptly if you feel unwell, uncomfortable, or need assistance.",
    ],
  },
  {
    title: "Respect the outdoors",
    points: [
      "Leave no litter behind. Carry your waste with you or use bins where available.",
      "Avoid loud music and speakers so everyone can enjoy the natural surroundings.",
      "Do not pick flowers or disturb plants, wildlife, or natural habitats.",
      "Avoid strong fragrances out of consideration for fellow trekkers and wildlife.",
    ],
  },
  {
    title: "What to wear and bring",
    points: [
      "Wear comfortable, breathable clothing and suitable footwear for the trail.",
      "Keep valuables and expensive accessories to a minimum.",
      "Bring the personal essentials and any medication you may need during the trek.",
    ],
  },
  {
    title: "Arrival & payment",
    points: [
      "Arrive at the confirmed meeting point on time and check in with your trek leader.",
      "Carry sufficient cash to help make check-in smooth, especially where digital payment may not be available.",
      "Please complete any outstanding trek payment with the team on arrival, before the trek begins.",
    ],
  },
  {
    title: "Keep it safe and respectful",
    points: [
      "Smoking and alcohol are not permitted during the trek.",
      "Keep a safe distance from cliff edges and deep waterfall areas. Avoid risky photos or videos.",
      "Treat trek leaders and fellow participants with respect and help maintain a supportive group atmosphere.",
    ],
  },
];

const TrekAdvisory = () => (
  <main className="mx-auto max-w-5xl rounded-3xl bg-gradient-to-br from-sky-50 via-blue-50 to-slate-50 px-4 py-8 text-stone-800 sm:px-6 sm:py-12 lg:px-8">
    <header className="mb-8 rounded-2xl bg-gradient-to-r from-blue-950 to-blue-800 px-6 py-8 text-white shadow-md sm:px-9 sm:py-10">
      <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-sky-200">
        Before you hit the trail
      </p>
      <h1 className="text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
        Trek Advisory
      </h1>
      <p className="mt-3 max-w-2xl text-sm leading-6 text-blue-50 sm:text-base">
        A few simple guidelines to help you prepare, check in smoothly, and
        enjoy a safe and respectful trek together.
      </p>
    </header>

    <div className="grid gap-4 sm:grid-cols-2">
      {guidelines.map((guideline, index) => (
        <section
          key={guideline.title}
          className="rounded-2xl border border-sky-200 bg-white/90 p-5 shadow-sm sm:p-6"
        >
          <div className="mb-4 flex items-center gap-3">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-blue-950">
              {String(index + 1).padStart(2, "0")}
            </span>
            <h2 className="text-base font-semibold leading-6 text-slate-900 sm:text-lg">
              {guideline.title}
            </h2>
          </div>
          <ul className="space-y-3">
            {guideline.points.map((point) => (
              <li
                key={point}
                className="flex gap-3 text-sm leading-6 text-slate-700 sm:text-base"
              >
                <span
                  aria-hidden="true"
                  className="mt-[0.65rem] h-1.5 w-1.5 shrink-0 rounded-full bg-blue-700"
                />
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>

    <p className="mt-6 rounded-xl border border-sky-200 bg-sky-100/70 px-5 py-4 text-sm leading-6 text-blue-950 sm:text-base">
      By joining the trek, participants agree to follow these guidelines and
      the trek leader’s instructions to help keep the experience safe and
      enjoyable for everyone.
    </p>
  </main>
);

export default TrekAdvisory;
